import { RouteConfig } from "vue-router";

export default {
	name: 'loginHelp',
	path: '/login-help',
	component: () => import('../../../feature/Auth/views/AuthViaDigitalSignHelp.vue'),
	meta: {
		layout: 'authorization',
		authRequired: false
	}
} as RouteConfig;